export default "__VITE_ASSET__342527a6__"